module.exports = __webpack_public_path__ + "img/tq.a0d1b600.png";